import { FulfillmentGroupPickStatus } from "@redotech/redo-model/fulfillments/fulfillment-group";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

// TODO: We have an order schema, but if we use it and the actual type is incorrect this will fail.
// We need a more standard order model to use, then we can strongly type this.
// For now we use catchall to handle the incompatibility between zod types and mongoose types.
const OrderWithPickStatusSchema = z
  .object({
    _id: zExt.objectId(),
    pickStatuses: z.array(z.nativeEnum(FulfillmentGroupPickStatus)),
  })
  .catchall(z.any());

export const getOrdersWithPickStatus = {
  name: "getOrdersWithPickStatus" as const,
  input: z.object({ orderIds: z.array(z.string()), teamId: z.string() }),
  output: z.object({
    orders: z.array(OrderWithPickStatusSchema),
  }),
};
